<template>
  <div>
    <!-- Report-level fields not covered by EditSampleForm. The accredited -->
    <!-- flag is report-wide (a report references a labsample with N -->
    <!-- analyses); it is sent at payload root, distinct from the per-analysis -->
    <!-- accreditedTest in the analyses step. -->
    <el-row :gutter="20">
      <el-col :span="6">
        <FormItem :label="$t('advancedRevision.wizard.reportAccredited')">
          <el-switch v-model="form.accredited" />
        </FormItem>
      </el-col>
      <el-col :span="6">
        <FormItem :label="$t('advancedRevision.wizard.lastReportDate')">
          <el-date-picker
            v-model="form.sample.lastReportDate"
            type="date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </FormItem>
      </el-col>
      <el-col :span="6">
        <FormItem :label="$t('advancedRevision.wizard.acceptedAt')">
          <el-date-picker
            v-model="form.sample.acceptedAt"
            type="date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
          />
        </FormItem>
      </el-col>
      <el-col :span="6">
        <FormItem :label="$t('advancedRevision.wizard.sampleAnalysisStart')">
          <el-date-picker
            v-model="form.sample.sampleAnalysisStart"
            type="date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            @change="form.sample.sampleAnalysisStartTouched = true"
          />
        </FormItem>
      </el-col>
      <el-col :span="6">
        <FormItem :label="$t('advancedRevision.wizard.sampleAnalysisEnd')">
          <el-date-picker
            v-model="form.sample.sampleAnalysisEnd"
            type="date"
            format="dd-MM-yyyy"
            value-format="yyyy-MM-dd"
            style="width: 100%"
            @change="form.sample.sampleAnalysisEndTouched = true"
          />
        </FormItem>
      </el-col>
    </el-row>

    <el-divider />

    <!-- Shared sample editor (product, lot, sampling info, address...). -->
    <EditSampleForm
      :initialData="editableSample"
      showSamplingInfo
      @update="onSampleUpdate"
    />
  </div>
</template>

<script>
  import FormItem from '@/components/FormItem.vue';
  import EditSampleForm from '@/views/analysesStatusManagement/EditSampleForm.vue';

  // Contract `sample` fields owned by EditSampleForm — kept in sync with the
  // shared form on every update. Report dates / accredited live on form directly.
  const SAMPLE_KEYS = [
    'productCode',
    'productName',
    'customerProductName',
    'lot',
    'date',
    'sector',
    'sampleDescription',
    'packagesNumber',
    'finalCustomer',
    'samplingInfo',
    'notes',
    'comments',
    'costCenter',
    'addressId',
    'customerAddress',
    'analysisNotes',
    'labNotes',
    'customerHeaderData',
    'address',
    'addressCountryPatch',
  ];

  export default {
    name: 'RevisionSampleStep',
    components: { FormItem, EditSampleForm },
    props: {
      form: { type: Object, required: true },
      // The full labsample (getLabSample) — seeds EditSampleForm with the rich
      // fields the search row lacks (customerId, samplingInfo, notes...).
      labSample: { type: Object, required: true },
    },
    data() {
      return {
        editableSample: {
          ...this.labSample,
          samplingInfo: this.labSample.samplingInfo || null,
          addressCountryPatch: this.form.sample.addressCountryPatch,
        },
      };
    },
    methods: {
      onSampleUpdate(data) {
        // Mirror only the contract-relevant fields into the shared form.sample,
        // which buildPayload reads.
        SAMPLE_KEYS.forEach((key) => {
          this.$set(this.form.sample, key, data[key]);
        });
      },
    },
  };
</script>
